function displaySliceId(sliceID: string) {
  return sliceID === "1" ? "SOD" : sliceID;
}

export { displaySliceId };
